import { IResponse } from "models";

export enum ActionType {
  GET_SECOND_SECTION_DATA = "action/GET_SECOND_SECTION_DATA",
  GET_SECOND_SECTION_DATA_SUCCESS = "action/GET_SECOND_SECTION_DATA_SUCCESS",
  GET_SECOND_SECTION_DATA_ERROR = "action/GET_SECOND_SECTION_DATA_ERROR",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface ISecondSectionPayload {
  start_date: string;
  end_date: string;
  designation_id: any;
}

export interface ISecondSectionResponse extends IResponse {
  result: any;
}
